export default {
  en: {
    ACCOUNT_BILLING_PAUSED: 'Your numbers have been paused due to nonpayment. Go to <a href=\'/#/dashboard/user-billing\'>Settings > Billing Settings</a> to add a new credit card to your account.',
    UPLOAD_KYC_NOTIFICATION_MESSAGE: 'Please <a href=\'/#/dashboard/user-billing\'>verify</a> your credit card to avoid service disruption.',
    
  }
};